// extracted by mini-css-extract-plugin
export var emailBlockLink = "_j9-0";